import React from "react";

import { Box, Button, Hidden, useTheme } from "@origin-digital/ods-core";

import { IconSearch } from "@origin-digital/ods-icons";
import styled from "styled-components";

const ButtonWrapper = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "right",
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "auto",

  [theme.breakpoints.up("lg")]: {
    width: "auto",
    marginRight: 0,
  },

  "& button": {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    width: "auto",
    padding: 0,

    [theme.breakpoints.up("lg")]: {
      width: "auto",
      position: "relative",

      "& svg": {
        width: theme.shape.iconSizes.xxsmall,
        height: theme.shape.iconSizes.xxsmall,
      },
    },
  },
}));

export const helpSupportButtonMetadata = {
  name: "help",
  title: "Help",
  ariaLabel: "Go to Help and Support page",
};

export const HelpSupportButton = ({
  onClick,
  secondaryColor = false,
}: {
  onClick?: () => void;
  secondaryColor?: boolean;
}) => {
  const { name, title, ariaLabel } = helpSupportButtonMetadata;
  const { palette } = useTheme();

  return (
    <ButtonWrapper>
      <Hidden above="lg">
        <ButtonContainer
          borderRadius="large"
          backgroundColor={
            secondaryColor
              ? palette.backgroundColor.tertiary
              : palette.backgroundColor.grey
          }
          data-id="mobile-help-support-button"
        >
          <Button
            icon={<IconSearch variant="solid" color="neutralDark" />}
            onClick={onClick}
            variant="text"
            size="xsmall"
            color="secondaryB"
            id={`${name}-button`}
            aria-label={ariaLabel}
            muiProps={{
              style: {
                paddingLeft: "16px",
                paddingRight: "12px",
              },
            }}
          >
            Help
          </Button>
        </ButtonContainer>
      </Hidden>
      <Hidden below="lg">
        <ButtonContainer
          borderRadius="large"
          backgroundColor={
            secondaryColor
              ? palette.backgroundColor.tertiary
              : palette.backgroundColor.grey
          }
          data-id="desktop-help-support-button"
        >
          <Button
            variant="text"
            color="secondaryB"
            size="small"
            onClick={onClick}
            id={`${name}-button`}
            aria-label={ariaLabel}
            icon={<IconSearch variant="solid" color="neutralDark" />}
            muiProps={{
              style: {
                paddingLeft: "16px",
                paddingRight: "12px",
              },
            }}
          >
            {title}
          </Button>
        </ButtonContainer>
      </Hidden>
    </ButtonWrapper>
  );
};
